import React from 'react';
import {useSelector} from 'react-redux';
import {Route} from 'react-router-dom';
import NoMatch from './noMatch';
import Orders from './orders';
import OrdersV2 from './ordersV2';
import {
  FEATURE_RESTRICTION_IDS,
  getOrderV2Restriction
} from '../../helpers/constants/restrictions';
import RestrictedArea from '../../components/layout/RestrictedArea';

const OfflineRoutes = () => {
  const isOnline = useSelector(
    (state) => state.globalNotificationsReducer.isNetworkOnline
  );
  const serviceFeatures = useSelector(
    (state) => state.user?.activeLocation?.AllowedServiceFeatures
  );

  return (
    <>
      <RestrictedArea
        restrictions={[]}
        features={[FEATURE_RESTRICTION_IDS.ORDERS]}
      >
        <Route path='/orders' component={Orders} />
      </RestrictedArea>
      <RestrictedArea
        restrictions={[]}
        features={[getOrderV2Restriction(serviceFeatures)]}
      >
        <Route path='/orders-v2' component={OrdersV2} />
      </RestrictedArea>
      {!isOnline && (
        <Route path='*'>
          <NoMatch />
        </Route>
      )}
    </>
  );
};

export default OfflineRoutes;
